import { formatStringList } from "utils";

export const earnLiterals = {
  vaultWarningToast: {
    message: (nonActiveCurrencies: string[]) =>
      `Withdrawals for the ${formatStringList(
        nonActiveCurrencies
      )} vault${nonActiveCurrencies.length ? 's' : ''} are temporarily on hold. We're actively working to restore access as quickly as possible. Your funds are safe, and we thank you for your patience during this short time.`,
  },
};
